import { requests } from '@/libs/axios/axios'
import { NotificationEndPoints } from '../notification-endpoints'
import { AxiosResponse } from 'axios'
const getNotifications = async (): Promise<AxiosResponse> => {
  return requests.put(NotificationEndPoints.UPDATE_ALL_NOTIFICATION_READ, {})
}
export default getNotifications
